import { render, staticRenderFns } from "./InvoiceProductsTable.vue?vue&type=template&id=b908a040&"
import script from "./InvoiceProductsTable.vue?vue&type=script&lang=js&"
export * from "./InvoiceProductsTable.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceProductsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports